import Splide from '@splidejs/splide';

const EL = '.js-show-reviews'
const ELS = document.querySelectorAll(EL);
const MORE = document.querySelectorAll('.js-reviews-more');

MORE.forEach((EL) => {
  EL.addEventListener('click', (e) => {
    e.preventDefault()

    e.currentTarget.parentNode.classList.add('is-open')
  })
})

ELS.forEach((EL) => {
  new Splide( EL, {
    perPage: 3,
    gap: 70,
    pagination: true,
    autoHeight: true,
    breakpoints: {
      '1024': {
        perPage: 1,
      },
    },
  } ).mount();
});
